module.exports = __webpack_public_path__ + "static/2_1_search-2_RO-4c9b148111d1df0e5b4f62a0f60fb4dd.svg";